<template>
  <footer class="footerComponent">
    <span class="footerComponent__copyright"> {{ $t('footer_copyright') }} </span>
    <img :src="getImageLogo()" width="auto" height="20" alt="logo aerolinea">
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  methods: {
    getImageLogo: function () {
      let url = this.$store.getters.getConfigUrls.staticUrl.split('/')
      url[url.length - 1] = 'header.jpg'
      return url.join('/')
    }
  }
}
</script>

<style lang="sass">
\:root
  --FooterComponent-color-background: var(--color-overlay-05)
  --FooterComponent-color-onBackground: var(--color-onBackground)
.footerComponent
  padding: 1rem
  width: 100%
  display: flex
  justify-content: space-between
  flex-direction: column
  background-color: var(--FooterComponent-color-background)
  color: var(--FooterComponent-color-onBackground)
  font-size: var(--font-size-sm)
  transition: width .2s ease
  will-change: width
  align-items: center
  &__copyright
    margin-bottom: 1rem
@media (min-width: 992px)
  .footerComponent
    font-size: var(--font-size-xs)
    flex-direction: row
    &__copyright
      margin-bottom: 0
  .--summary-active
    .footerComponent
      width: calc(100% - 255px)
  .--actionNav-active
    .footerComponent
      padding: 1rem 1rem 4.5rem
</style>
